export default "https://assets.pclncdn.com/web/next-landing/49d3d019e1/_next/static/images/san-francisco-15dc559bb13187f21236a3824c84ba24.webp";